import { observable } from 'mobx'
import {
    DropdownListQuestion,
    GridQuestion,
    MultipleChoiceQuestion,
    PercentageQuestion,
    PriorityQuestion,
    SingleChoiceQuestion,
    SmartGridQuestion,
    UrlVariableQuestion,
    TextBoxListQuestion,
} from '../../../../Models/Question'

class QuestionOptionStore {
    constructor(store) {
        this.store = store
    }

    @observable data = []

    columns = [
        {
            key: 'optionId',
            name: 'Option Id',
        },
        {
            key: 'set',
            name: 'Set',
        },
        {
            key: 'value',
            name: 'Value',
        },
    ]

    @observable questionId = ''

    handleInput = (e) => {
        this.questionId = e.target.value
    }

    handleSubmit = async () => {
        try {
            const response = await this.store.http.get(`/api/question/${this.questionId}/1`)
            this.data = []
            let questionItem
            switch (response.question.questionTypeCode) {
                case 'CH':
                    questionItem = new MultipleChoiceQuestion(response.question)
                    break
                case 'OD':
                    questionItem = new PriorityQuestion(response.question)
                    break
                case 'PC':
                    questionItem = new PercentageQuestion(response.question)
                    break
                case 'RD':
                    questionItem = new SingleChoiceQuestion(response.question)
                    break
                case 'SB':
                    questionItem = new DropdownListQuestion(response.question)
                    break
                case 'TB':
                    questionItem = new GridQuestion(response.question)
                    break
                case 'UV':
                    questionItem = new UrlVariableQuestion(response.question)
                    break
                case 'TL':
                    questionItem = new TextBoxListQuestion(response.question)
                    break
                case 'SG':
                    questionItem = new SmartGridQuestion(response.question)
                    break
                default:
                    questionItem = null
                    break
            }

            if (questionItem) {
                const tempY = questionItem.hasOwnProperty('optionSet') ? questionItem.optionSet.options.map((option) => ({
                    optionId: option.id,
                    value: option
                        .getTitle('en_GB', response.question.metadata.initialLocale),
                    set: 'Y',
                }))
                    : questionItem.optionSetY.options.map((option) => ({
                        optionId: option.id,
                        value: option
                            .getTitle('en_GB', response.question.metadata.initialLocale),
                        set: 'Y',
                    }))

                const tempX = questionItem.hasOwnProperty('optionSetX') ? questionItem.optionSetX.options.map((option) => ({
                    optionId: option.id,
                    value: option
                        .getTitle('en_GB', response.question.metadata.initialLocale),
                    set: 'X',
                })) : []

                this.data = [...tempY, ...tempX]
            } else {
                this.data = []
            }
        } catch (e) {
            this.store.handleError({ body: `Something went wrong: ${e.message}`, level: 'error' })
        }
    }
}
export default QuestionOptionStore
